module.exports = __webpack_public_path__ + "static/media/gh.3dbb4781.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gh.svg
// module id = 2098
// module chunks = 0